import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { KnmRegistryTypeEnum } from '../enums/KnmRegistryTypeEnum';
import { IKnmCheckSubjectResult } from '../interfaces/IKnmCheckSubjectResult';
import { IKnmRegistryItem } from '../interfaces/IKnmRegistryItem';
import { IOkved } from '../interfaces/IOkved';

export async function setRegistryCheck(
  knmId: number,
  guid: string,
  inn: string,
  ogrn: string,
): Promise<IKnmCheckSubjectResult> {
  return apiGet<IKnmCheckSubjectResult>(
    `${getServiceBaseURL(
      APIServiceEnum.KNM_SERVICE,
    )}/registry/check-subject/${knmId}?guid=${guid}&inn=${inn}&ogrn=${ogrn}`,
  );
}

export async function getRegistryCheckResults(knmId: number): Promise<IKnmCheckSubjectResult> {
  return apiGet<IKnmCheckSubjectResult>(
    `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/registry/check-subject/result/${knmId}`,
  );
}

export async function fetchToserInfo(id: string): Promise<IKnmRegistryItem[]> {
  return apiGet<IKnmRegistryItem[]>(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/registry/toser/${id}`, true);
}

export async function fetchSpvInfo(id: string): Promise<IKnmRegistryItem[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/registry/spv/${id}`, true);
}

export async function fetchOezInfo(id: string): Promise<IKnmRegistryItem[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/registry/oez/${id}`, true);
}

export async function fetchRegistryEgrul(id: number): Promise<IKnmRegistryItem[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/registry/egrul/${id}`, true);
}

export async function fetchRegistryEgrip(id: number): Promise<IKnmRegistryItem[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/registry/egrip/${id}`, true);
}

export async function fetchMspInfo(id: string): Promise<IKnmRegistryItem[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/registry/msp/${id}`, true);
}

export async function exportRegistryByType(
  id: string,
  registryType: keyof typeof KnmRegistryTypeEnum,
  format: ExportFormatsEnum,
): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('format', format);
  params.set('reg', registryType.toUpperCase());
  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost<IExport>({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/registry/export/${id}?${params}` });
}

export async function fetchRegistryExportOkved(inn: string, ogrn: string): Promise<IOkved> {
  const queryParams = new URLSearchParams({
    inn,
    ogrn,
  });

  return apiGet<IOkved>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/registry/export/okved?${queryParams}`);
}
